
import { selectChatUnreadNotifications } from 'containers/Chats/chatSlice'
import { selectIsLoggedIn } from 'containers/Login/loginSlice'
import { useHistory, useLocation } from 'react-router-dom'
import useTranslation from 'hooks/useTranslation'
import Message from 'components/icons/Message'
import { useSelector } from 'react-redux'
import { isIos } from 'utils/isMobile'
import './style.scss'

const BottomBar = () => {
  const unreadMessages = useSelector(selectChatUnreadNotifications)
  const isLoggedIn = useSelector(selectIsLoggedIn)
  const { pathname } = useLocation()
  const ios = isIos()

  const { t } = useTranslation('menu')
  const { push } = useHistory()

  return (
    <div className={`bottomBar ${pathname === '/' || pathname === '/dashboard' ? 'gray' : ''} ${ios ? 'ios' : ''}`}>
      <div
        className={`bottomBar__button ${(pathname === '/dashboard' || (pathname === '/' && isLoggedIn)) ? 'active' : ''}`}
        onClick={() => push('/dashboard')}>
        <i className='icon icon--dashboard s24'></i>
        <span>{t('dashboard')}</span>
      </div>

      <div
        className={`bottomBar__button ${pathname === '/chat' ? 'active' : ''}`}
        onClick={() => push('/chat')}>
        <Message isNewMessage={!!unreadMessages} />
        <span>{t('messagesShort')}</span>
      </div>

      <div
        className={`bottomBar__button ${(pathname === '/home' || (pathname === '/' && !isLoggedIn)) ? 'active' : ''}`}
        onClick={() => push('/home')}>
        <i className='icon icon--plus s24'></i>
        <span>{t('order')}</span>
      </div>

      <div
        className={`bottomBar__button ${pathname === '/account' ? 'active' : ''}`}
        onClick={() => push('/account')}>
        <i className='icon icon--user s24'></i>
        <span>{t('account')}</span>
      </div>

      <div
        className={`bottomBar__button ${pathname === '/help' ? 'active' : ''}`}
        onClick={() => push('/help')}>
        <i className='icon icon--help s24'></i>
        <span>{t('help')}</span>
      </div>
    </div>
  )
}

export default BottomBar